// Página de Processadores do merchant (superAdmin): as CREDENCIAIS.
//
// Separada de "Meios de pagamento" de propósito: aqui se cadastra a credencial uma vez, lá se
// escolhe qual delas atende cada método de cada white label.
import { useTranslation } from "react-i18next"

import { AppBreadcrumb } from "@/components/layout/app-breadcrumb"
import { Header } from "@/components/layout/header"
import { FRONTEND_ROUTES } from "@/constants"
import { MerchantProcessorsPanel } from "@/features/merchant-processors"

export function MerchantProcessorsPage() {
  const { t } = useTranslation()

  return (
    <main className="flex w-full flex-1 flex-col">
      <Header>
        <AppBreadcrumb
          links={[
            {
              href: FRONTEND_ROUTES.DASHBOARD.href,
              label: t("sidebar.dashboard"),
            },
            {
              label: t("sidebar.administration"),
            },
            {
              label: t("sidebar.merchantProcessors"),
            },
          ]}
        />
      </Header>
      <section className="flex flex-1 flex-col gap-4 overflow-x-hidden p-4 @container">
        <div className="flex flex-col gap-1">
          <h1 className="page-title">
            {t("pages.adminMerchantProcessors.title")}
          </h1>
          <p className="text-sm text-muted-foreground">
            {t("pages.adminMerchantProcessors.subtitle")}
          </p>
        </div>
        <MerchantProcessorsPanel />
      </section>
    </main>
  )
}
